<template>
  <div class="col-options-data-dialog">
    <el-collapse v-model="activeNames">
      <el-collapse-item @mousedown.native="collapseMouseDown($event, '1')" title="基础设置" name="1" class="padding0">
        <div class="content" v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '1')">
          <collapsibleItem
            :name="collapse.top.title"
            :type="collapse.top.type"
            :is-active="collapse.top.isActive"
            @collapsibleItemClick="collapsibleItemClickHandle($event, 1)"
          >
            <div slot="heading">{{ collapse.top.title }}</div>
            <div slot="body">
              <div v-if="collapseDataActiveNames.length !== 0 && collapseDataActiveNames.find(it => it == 1) > -1">
                <div class="content-item">
                  <el-checkbox v-model="isShowTop">显示标题栏</el-checkbox>
                </div>
                <div v-if="isShowTop" class="content-item">
                  <slider-and-input
                    class="mt16"
                    :value.sync="topHeight"
                    title="高度"
                    :sliderMax="250"
                    :sliderMin="0"
                    suffix="px"
                  />
                </div>
                <template v-if="isShowTop">
                  <div
                    v-for="(titleComponent, index) in titleComponents[0].elementOptions"
                    :key="index"
                    class="content-item"
                  >
                    <el-checkbox
                      :value.sync="titleComponent.isShow"
                      :disabled="titleComponent.disabled"
                      @change="checkboxDisplayHandle($event, 0, titleComponent)"
                      >{{ titleComponent.title }}</el-checkbox
                    >
                  </div>
                </template>
              </div>
            </div>
          </collapsibleItem>
          <collapsibleItem
            :name="collapse.left.title"
            :type="collapse.left.type"
            :is-active="collapse.left.isActive"
            @collapsibleItemClick="collapsibleItemClickHandle($event, 2)"
          >
            <div slot="heading">{{ collapse.left.title }}</div>
            <div slot="body">
              <div v-if="collapseDataActiveNames.length !== 0 && collapseDataActiveNames.find(it => it == 2) > -1">
                <div class="content-item">
                  <el-checkbox v-model="isShowLeft">显示左侧栏</el-checkbox>
                </div>
                <div v-if="isShowLeft" class="content-item">
                  <slider-and-input
                    class="mt16"
                    :value.sync="leftWidth"
                    title="宽度"
                    :sliderMax="250"
                    :sliderMin="0"
                    suffix="px"
                  />
                </div>
                <template v-if="isShowLeft">
                  <div
                    v-for="(titleComponent, index) in titleComponents[2].elementOptions"
                    :key="index"
                    class="content-item"
                  >
                    <el-checkbox
                      :value.sync="titleComponent.isShow"
                      :disabled="titleComponent.disabled"
                      @change="checkboxDisplayHandle($event, 2, titleComponent)"
                      >{{ titleComponent.title }}</el-checkbox
                    >
                  </div>
                  <template v-if="request_prefix.includes('app')">
                    <cx-check-box :value.sync="isDrawerModeL">抽屉模式</cx-check-box>
                    <template v-if="isDrawerModeL">
                      <cx-check-box :value.sync="drawerL">显示抽屉</cx-check-box>
                      <cx-select :value.sync="inBodyL" :selectOptions="drawerSelectOptions" title="抽屉位置" />
                    </template>
                  </template>
                </template>
              </div>
            </div>
          </collapsibleItem>
          <collapsibleItem
            :name="collapse.right.title"
            :type="collapse.right.type"
            :is-active="collapse.right.isActive"
            @collapsibleItemClick="collapsibleItemClickHandle($event, 3)"
          >
            <div slot="heading">{{ collapse.right.title }}</div>
            <div slot="body">
              <div v-if="collapseDataActiveNames.length !== 0 && collapseDataActiveNames.find(it => it == 3) > -1">
                <div class="content-item">
                  <el-checkbox v-model="isShowRight">显示右侧栏</el-checkbox>
                </div>
                <div v-if="isShowRight" class="content-item">
                  <slider-and-input
                    class="mt16"
                    :value.sync="rightWidth"
                    title="宽度"
                    :sliderMax="250"
                    :sliderMin="0"
                    suffix="px"
                  />
                </div>
                <template v-if="isShowRight">
                  <div
                    v-for="(titleComponent, index) in titleComponents[3].elementOptions"
                    :key="index"
                    class="content-item"
                  >
                    <el-checkbox
                      :value.sync="titleComponent.isShow"
                      :disabled="titleComponent.disabled"
                      @change="checkboxDisplayHandle($event, 3, titleComponent)"
                      >{{ titleComponent.title }}</el-checkbox
                    >
                  </div>
                  <template v-if="request_prefix.includes('app')">
                    <cx-check-box :value.sync="isDrawerModeR">抽屉模式</cx-check-box>
                    <template v-if="isDrawerModeR">
                      <cx-check-box :value.sync="drawerR">显示抽屉</cx-check-box>
                      <cx-select :value.sync="inBodyR" :selectOptions="drawerSelectOptions" title="抽屉位置" />
                    </template>
                  </template>
                </template>
              </div>
            </div>
          </collapsibleItem>
          <collapsibleItem
            :name="collapse.bottom.title"
            :type="collapse.bottom.type"
            :is-active="collapse.bottom.isActive"
            @collapsibleItemClick="collapsibleItemClickHandle($event, 4)"
          >
            <div slot="heading">{{ collapse.bottom.title }}</div>
            <div slot="body">
              <div v-if="collapseDataActiveNames.length !== 0 && collapseDataActiveNames.find(it => it == 4) > -1">
                <div class="content-item">
                  <el-checkbox v-model="isShowBottom">显示底部栏</el-checkbox>
                </div>
                <div v-if="isShowBottom" class="content-item">
                  <slider-and-input
                    class="mt16"
                    :value.sync="bottomHeight"
                    title="高度"
                    :sliderMax="250"
                    :sliderMin="0"
                    suffix="px"
                  />
                </div>
                <template v-if="isShowBottom">
                  <div
                    v-for="(titleComponent, index) in titleComponents[1].elementOptions"
                    :key="index"
                    class="content-item"
                  >
                    <el-checkbox
                      :value.sync="titleComponent.isShow"
                      :disabled="titleComponent.disabled"
                      @change="checkboxDisplayHandle($event, 1, titleComponent)"
                      >{{ titleComponent.title }}</el-checkbox
                    >
                  </div>
                </template>
              </div>
            </div>
          </collapsibleItem>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import { findTabs, replaceUrlParam } from "utils"
import { layout_title_drawer_button_children } from "materials/button/menus"
export default {
  props: {
    options: { type: Object },
    container_id: { type: [Number, String] },
    rect_id: { type: [Number, String] }
  },
  watch: {
    listPageTemplateEncId: {
      handler: function (val) {
        this.$API
          .queryComponentContent({
            encId: val
          })
          .then(res => {
            this.currentListPageCover = res.data.data.cover
            this.currentListPageTitle = res.data.data.title
          })
      },
      deep: false
    },
    detailPageTemplateEncId: {
      handler: function (val) {
        this.$API
          .queryComponentContent({
            encId: val
          })
          .then(res => {
            this.currentDetailPageCover = res.data.data.cover
            this.currentDetailPageTitle = res.data.data.title
          })
      },
      deep: false
    }
  },
  data() {
    return {
      this1: this,
      activeNames: ["0"],
      collapseActiveNames: [],
      drawerSelectOptions: [
        {
          label: "页面",
          value: true
        },
        {
          label: "组件",
          value: false
        }
      ],
      collapse: {
        top: {
          title: "标题栏",
          type: "top",
          isActive: false
        },
        bottom: {
          title: "底部栏",
          type: "bottom",
          isActive: false
        },
        left: {
          title: "左侧栏",
          type: "left",
          isActive: false
        },
        right: {
          title: "右侧栏",
          type: "right",
          isActive: false
        },
        list: {
          title: "列表页",
          type: "list",
          isActive: false
        },
        detail: {
          title: "详情页",
          type: "detail",
          isActive: false
        }
      }, // 用来存放当前数据组和图例设置里面的展开收起状态
      collapseDataActiveNames: [],
      titleComponents: {}, // 用户配置项回显
      listPageData: {},
      detailPageData: {},
      showNavMenu: true,
      showApplicationName: true,
      showSearchComponent: true,
      showBreadCrumbs: true,
      detailPageShowBreadCrumbs: true,
      currentListPageCover: "",
      currentListPageTitle: "",
      currentDetailPageCover: "",
      currentDetailPageTitle: ""
    }
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    isShowTop: {
      get() {
        return this.checkAndSetPrimaryVal(this.options.titleOptions[0], "isShow", "isShow", true)
      },
      set(newVal) {
        if (!newVal) {
          this.titleComponents[0].elementOptions.forEach(item => {
            this.checkboxDisplayHandle(false, 0, item)
          })
        }
        const completeParam = {
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id,
          directionIndex: 0,
          changingTitleElement: true
        }
        this.$changeOptionsEV(newVal, "isShow", false, false, completeParam)
      }
    },
    topHeight: {
      get() {
        return this.checkAndSetPrimaryVal(this.options.titleOptions[0], "height", "height", 60)
      },
      set(newVal) {
        const completeParam = {
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id,
          directionIndex: 0,
          changingTitleElement: true
        }
        this.$changeOptionsEV(newVal, "height", false, false, completeParam)
      }
    },
    isShowBottom: {
      get() {
        return this.checkAndSetPrimaryVal(this.options.titleOptions[1], "isShow", "isShow", true)
      },
      set(newVal) {
        if (!newVal) {
          this.titleComponents[1].elementOptions.forEach(item => {
            this.checkboxDisplayHandle(false, 1, item)
          })
        }
        const completeParam = {
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id,
          directionIndex: 1,
          changingTitleElement: true
        }
        this.$changeOptionsEV(newVal, "isShow", false, false, completeParam)
      }
    },
    bottomHeight: {
      get() {
        return this.checkAndSetPrimaryVal(this.options.titleOptions[1], "height", "height", 60)
      },
      set(newVal) {
        const completeParam = {
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id,
          directionIndex: 1,
          changingTitleElement: true
        }
        this.$changeOptionsEV(newVal, "height", false, false, completeParam)
      }
    },
    isShowLeft: {
      get() {
        return this.checkAndSetPrimaryVal(this.options.titleOptions[2], "isShow", "isShow", true)
      },
      set(newVal) {
        if (!newVal) {
          this.titleComponents[2].elementOptions.forEach(item => {
            this.checkboxDisplayHandle(false, 2, item)
          })
        }
        const completeParam = {
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id,
          directionIndex: 2,
          changingTitleElement: true
        }
        this.$changeOptionsEV(newVal, "isShow", false, false, completeParam)
      }
    },
    leftWidth: {
      get() {
        return this.checkAndSetPrimaryVal(this.options.titleOptions[2], "width", "width", 60)
      },
      set(newVal) {
        const completeParam = {
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id,
          directionIndex: 2,
          changingTitleElement: true
        }
        this.$changeOptionsEV(newVal, "width", false, false, completeParam)
      }
    },
    isShowRight: {
      get() {
        return this.checkAndSetPrimaryVal(this.options.titleOptions[3], "isShow", "isShow", true)
      },
      set(newVal) {
        if (!newVal) {
          this.titleComponents[3].elementOptions.forEach(item => {
            this.checkboxDisplayHandle(false, 3, item)
          })
        }
        const completeParam = {
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id,
          directionIndex: 3,
          changingTitleElement: true
        }
        this.$changeOptionsEV(newVal, "isShow", false, false, completeParam)
      }
    },
    rightWidth: {
      get() {
        return this.checkAndSetPrimaryVal(this.options.titleOptions[3], "width", "width", 60)
      },
      set(newVal) {
        const completeParam = {
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id,
          directionIndex: 3,
          changingTitleElement: true
        }
        this.$changeOptionsEV(newVal, "width", false, false, completeParam)
      }
    },
    isDrawerModeL: {
      get() {
        const val = this.checkAndSetPrimaryVal(this.options, "isDrawerModeL", "isDrawerModeL")
        const hasBtn = this.options.titleOptions[0].elementOptions.find(item => item.options.drawerPosition === "L")
        if (val === true) {
          //将左侧的多级下拉改为点击激活
          this.checkMenuTriggerType("L")
          //检测自由布局头部框内是否有按钮开关，如果没有就要初始化一个
          if (hasBtn === undefined) {
            this.initDrawerBtn("L")
          }
          //显示左侧栏
          this.isShowLeft = true
        } else {
          //检测自由布局头部框内是否有按钮开关，如果有就要删除
          if (hasBtn !== undefined) {
            this.delDrawerBtn(hasBtn.elementInLayoutId)
          }
        }
        return val
      },
      set(val) {
        console.log("this.options,val :>> ", this.options, val)
        this.$changeOptionsEV(val, "isDrawerModeL")
      }
    },
    drawerL: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "drawerL", "drawerL", false)
      },
      set(val) {
        this.$changeOptionsEV(val, "drawerL")
      }
    },
    inBodyL: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "inBodyL", "inBodyL", false)
      },
      set(val) {
        this.$changeOptionsEV(val, "inBodyL")
      }
    },
    inBodyR: {
      get() {
        console.log("this.options :>> ", this.options)
        return this.checkAndSetPrimaryVal(this.options, "inBodyR", "inBodyR", false)
      },
      set(val) {
        console.log("val :>> ", val)
        this.$changeOptionsEV(val, "inBodyR")
      }
    },
    isDrawerModeR: {
      get() {
        const val = this.checkAndSetPrimaryVal(this.options, "isDrawerModeR", "isDrawerModeR")
        const hasBtn = this.options.titleOptions
          .find(it => it.type === "top")
          .elementOptions.find(item => item.options.drawerPosition === "R")
        if (val === true) {
          //将右侧的多级下拉改为点击激活
          this.checkMenuTriggerType("R")
          //检测自由布局头部框内是否有按钮开关，如果没有就要初始化一个
          if (hasBtn === undefined) {
            this.initDrawerBtn("R")
          }
          //显示右侧侧栏
          this.isShowRight = true
        } else {
          //检测自由布局头部框内是否有按钮开关，如果有就要删除
          if (hasBtn !== undefined) {
            this.delDrawerBtn(hasBtn.elementInLayoutId)
          }
        }
        return val
      },
      set(val) {
        console.log("this.options,val :>> ", this.options, val)
        this.$changeOptionsEV(val, "isDrawerModeR")
      }
    },
    drawerR: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "drawerR", "drawerR", false)
      },
      set(val) {
        this.$changeOptionsEV(val, "drawerR")
      }
    }
  },
  mounted() {},
  created() {
    // 获取分类、更多、分页组件的真实显示位置
    const titleOptions = this.options.titleOptions
    // 先给一个默认值
    this.titleComponents = [
      {
        directionIndex: 0,
        elementOptions: [
          {
            type: "classification",
            title: "显示分类",
            elementInLayoutId: 0,
            isShow: false,
            disabled: true
          },
          {
            type: "more",
            title: "显示更多按钮",
            elementInLayoutId: 1,
            isShow: false,
            disabled: true
          }
        ]
      },
      {
        directionIndex: 1,
        elementOptions: [
          {
            type: "classification",
            title: "显示分类",
            elementInLayoutId: 0,
            isShow: false,
            disabled: true
          },
          {
            type: "more",
            title: "显示更多按钮",
            elementInLayoutId: 1,
            isShow: false,
            disabled: true
          },
          {
            type: "pagination",
            title: "显示分页",
            elementInLayoutId: 2,
            isShow: true,
            disabled: false
          }
        ]
      },
      {
        directionIndex: 2,
        elementOptions: [
          {
            type: "classification",
            title: "显示分类",
            elementInLayoutId: 0,
            isShow: false,
            disabled: true
          },
          {
            type: "more",
            title: "显示更多按钮",
            elementInLayoutId: 1,
            isShow: false,
            disabled: true
          }
        ]
      },
      {
        directionIndex: 3,
        elementOptions: [
          {
            type: "classification",
            title: "显示分类",
            elementInLayoutId: 0,
            isShow: false,
            disabled: true
          },
          {
            type: "more",
            title: "显示更多按钮",
            elementInLayoutId: 1,
            isShow: false,
            disabled: true
          }
        ]
      }
    ]
    for (let i = 0; i < titleOptions.length; i++) {
      for (let j = 0; j < titleOptions[i].elementOptions.length; j++) {
        const classificationObj = this.titleComponents[i].elementOptions.find(item => item.type === "classification")
        const moreObj = this.titleComponents[i].elementOptions.find(item => item.type === "more")
        const paginationObj = this.titleComponents[i].elementOptions.find(item => item.type === "pagination")
        if (titleOptions[i].elementOptions[j].type === "classification") {
          classificationObj.isShow = titleOptions[i].elementOptions[j].isShow
          classificationObj.elementInLayoutId = titleOptions[i].elementOptions[j].elementInLayoutId
          classificationObj.isShow ? (classificationObj.disabled = false) : (classificationObj.disabled = true)
        } else if (titleOptions[i].elementOptions[j].type === "more") {
          moreObj.isShow = titleOptions[i].elementOptions[j].isShow
          moreObj.elementInLayoutId = titleOptions[i].elementOptions[j].elementInLayoutId
          moreObj.isShow ? (moreObj.disabled = false) : (moreObj.disabled = true)
        } else if (titleOptions[i].elementOptions[j].type === "pagination") {
          paginationObj.isShow = titleOptions[i].elementOptions[j].isShow
          // paginationObj.elementInLayoutId = titleOptions[i].elementOptions[j].elementInLayoutId
          paginationObj.disabled = false // 分页组件只会存在下面
        }
      }
    }
    console.log("this.titleComponents", this.titleComponents)
  },
  methods: {
    checkMenuTriggerType(type) {
      const titleOption = this.options.titleOptions.find(item => item.type === (type === "L" ? "left" : "right"))
      const directionIndex = type === "L" ? 2 : 3
      for (let i = 0; i < titleOption.elementOptions.length; i++) {
        if (titleOption.elementOptions[i].innerElement.includes("Menu")) {
          const completeParam = {
            container_id: this.ids.container_id,
            rect_id: this.ids.rect_id,
            directionIndex,
            elementInLayoutId: titleOption.elementOptions[i].elementInLayoutId,
            option_name: "menuTrigger",
            option_val: "click"
          }
          this.$store.dispatch(this.request_prefix + "/changeTitleOptions", completeParam)
        }
      }
    },
    initDrawerBtn(type) {
      const btn = JSON.parse(JSON.stringify(layout_title_drawer_button_children[0].attribute.options))
      btn.drawerPosition = type
      btn.isCustomComponent = true
      btn.name = type === "L" ? "左侧抽屉按钮" : "右侧抽屉按钮"
      btn.top = 0
      if (type === "L") {
        btn.left = 0
      } else {
        const rectElWidth = document.getElementsByClassName(
          this.$event.getIdsByStrId({
            container_id: this.ids.container_id,
            rect_id: this.ids.rect_id
          })
        )[0].offsetWidth
        btn.left = rectElWidth - btn.width
      }
      if (btn.hasOwnProperty("pluginName") === false) btn.pluginName = ["layoutTitleOptionDrawerPlugin"]
      else btn.pluginName.push("layoutTitleOptionDrawerPlugin")
      this.$store.dispatch(this.request_prefix + "/addComponentInLayoutAround", {
        container_id: this.ids.container_id,
        rect_id: this.ids.rect_id,
        direction: 0,
        elementOptions: btn
      })
    },
    delDrawerBtn(elementInLayoutId) {
      this.$store.dispatch(this.request_prefix + "/delLayoutAroundElement", {
        container_id: this.ids.container_id,
        rect_id: this.ids.rect_id,
        directionIndex: 0,
        elementInLayoutId
      })
    },
    collapseMouseDown($event, val) {
      if ($event.target.classList[0] === "el-collapse-item__header") {
        const _index = this.collapseActiveNames.findIndex(it => it === val)
        _index === -1 ? this.collapseActiveNames.push(val) : ""
      }
    },
    // 抽屉展开收起方法
    collapsibleItemClickHandle($event, index) {
      this.collapse[$event.type].isActive = $event.isActiveCopy
      const _index = this.collapseDataActiveNames.findIndex(it => it === index)
      _index === -1 ? this.collapseDataActiveNames.push(index + "") : ""
    },
    checkboxDisplayHandle(flag, direction, elementParam) {
      let titleOptions = JSON.parse(JSON.stringify(this.options.titleOptions))
      this.titleComponents[direction].elementOptions.find(
        it => it.elementInLayoutId === elementParam.elementInLayoutId
      ).isShow = flag
      // 当改变显示位置时，需要将其他的显示位置设置为不显示,当取消显示位置时，需要将其他的显示位置设置为显示
      this.titleComponents.forEach((element, i) => {
        if (i !== direction) {
          element.elementOptions.forEach((item, j) => {
            if (item.type === elementParam.type) {
              if (flag) {
                item.disabled = true
              } else {
                item.disabled = false
              }
            }
          })
        }
      })

      const { directionIndex, elementInLayoutId } = findTabs(
        this.options,
        {
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id
        },
        elementParam.type
      )
      if (direction === directionIndex && elementParam.elementInLayoutId === elementInLayoutId) {
        // 说明是原来的位置，不需要改变
        titleOptions[direction].elementOptions.find(it => it.elementInLayoutId === elementInLayoutId).isShow = flag
      } else {
        // 说明是新的位置，需要改变
        const elementComponent = JSON.parse(
          JSON.stringify(
            this.options.titleOptions[directionIndex].elementOptions.find(
              it => it.elementInLayoutId === elementInLayoutId
            )
          )
        )
        // 同时返回数组下标
        const elementComponentIndex = this.options.titleOptions[directionIndex].elementOptions.findIndex(
          it => it.elementInLayoutId === elementInLayoutId
        )
        titleOptions[directionIndex].elementOptions.splice(elementComponentIndex, 1) // 删除原来的位置
        titleOptions[direction].elementOptions.push(elementComponent) // 添加到新的位置并且需要更新elementInLayoutId
        if (titleOptions[direction].elementOptions.length > 1) {
          titleOptions[direction].elementOptions.sort((a, b) => a.elementInLayoutId - b.elementInLayoutId) // 排序
          const newElementInLayoutId =
            titleOptions[direction].elementOptions[titleOptions[direction].elementOptions.length - 1]
              .elementInLayoutId + 1 // 最后一个元素的位置加1
          elementComponent.elementInLayoutId = newElementInLayoutId
          titleOptions[direction].elementOptions.find(it => it.elementInLayoutId === newElementInLayoutId).isShow = flag
        } else {
          titleOptions[direction].elementOptions.find(it => it.elementInLayoutId === elementInLayoutId).isShow = flag
        }
      }
      console.log("titleOptions", titleOptions)
      this.$changeOptionsEV(titleOptions, "titleOptions", false, false, false, true)
    },
    // 编辑列表页
    editPageHandle() {
      const listPageId = this.options.listPageId
      const newUrl = replaceUrlParam(window.location.href, "p", listPageId)
      window.open(newUrl, "_blank")
    },
    // 编辑页详情页
    editDetailPageHandle() {
      const detailPageId = this.options.detailPageId
      const newUrl = replaceUrlParam(window.location.href, "p", detailPageId)
      window.open(newUrl, "_blank")
    },
    // 保存列表页配置项
    async saveListPageDataHandle() {
      const listPageId = this.options.listPageId
      const type = this.request_prefix === "appStage" ? 1 : 0
      this.listPageData.page.listPageSetting.showApplicationName = this.showApplicationName
      this.listPageData.page.listPageSetting.showNavMenu = this.showNavMenu
      this.listPageData.page.listPageSetting.showBreadCrumbs = this.showBreadCrumbs
      this.listPageData.page.listPageSetting.showSearchComponent = this.showSearchComponent
      this.listPageData.version = this.listPageData.version + 1

      const portalData = {
        app: type,
        encPageId: listPageId,
        list: 1,
        domain: "138498cvm",
        content: JSON.parse(JSON.stringify(this.listPageData))
      }

      this.$API
        .saveWebJson({
          app: portalData.app,
          webJson: portalData
        })
        .then(res => {
          this.$message({
            customClass: "bigScreen_msg_backGroud",
            duration: 3000,
            type: "success",
            message: res.message
          })
        })
    },
    async saveDetailPageDataHandle() {
      const detailPageId = this.options.detailPageId
      const type = this.request_prefix === "appStage" ? 1 : 0
      this.detailPageData.page.detailPageSetting.showBreadCrumbs = this.detailPageShowBreadCrumbs
      this.detailPageData.version = this.detailPageData.version + 1

      const portalData = {
        app: type,
        encPageId: detailPageId,
        list: 1,
        domain: "138498cvm",
        content: JSON.parse(JSON.stringify(this.detailPageData))
      }

      this.$API
        .saveWebJson({
          app: portalData.app,
          webJson: portalData
        })
        .then(res => {
          this.$message({
            customClass: "bigScreen_msg_backGroud",
            duration: 3000,
            type: "success",
            message: res.message
          })
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.toolbar .padding0 ::v-deep .el-collapse-item__content {
  padding: 0 16px 0 16px !important;
}
.childPageSettingBtn {
  background: var(--leftMenuBgColor);
  border: 1px solid var(--themeColor);
  border-radius: 4px;
  font-size: 13px;
  line-height: 18px;
  text-align: center;
  color: var(--themeColor);
  padding: 5px 0;
}
.childPageSettingBtn:hover {
  cursor: pointer;
}
.layoutConfig-card {
  border: 1px solid #e9e9e9;
  border-radius: 4px;
  position: relative;
  .img-box {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    background-color: rgba(245, 246, 248, 1);
    background-position: center center;
    background-size: contain;
    background-clip: padding-box;
    background-repeat: no-repeat;
    background-size: 100%;
    height: 100%;
  }
  .footer {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    padding: 12px;
    gap: 9.13px;
    position: absolute;
    width: 100%;
    height: 42px;
    left: 0px;
    bottom: 0px;
    background: rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(14.6087px);
    .title {
      font-size: 13px;
      line-height: 18px;
      text-align: center;
      color: #000000;
    }
    .desc {
      cursor: pointer;
      font-weight: 400;
      font-size: 13px;
      line-height: 18px;
      color: #2b67ff;
    }
  }
  .header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 4px 4px 4px 12px;
    background: #fbfcfd;
    .title {
      font-weight: 500;
      font-size: 13px;
      line-height: 18px;
      color: rgba(0, 0, 0, 0.8);
    }
    .btn {
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      color: #2b67ff;
      cursor: pointer;
    }
  }
  .config-content {
    padding: 12px 12px 0 12px;
    font-weight: 400;
    font-size: 13px;
    line-height: 18px;
    color: rgba(0, 0, 0, 0.8);
  }
}
.cover {
  height: 132px;
}
</style>
